module.exports = __webpack_public_path__ + "static/watermelon-a8c90ae7a3c243c9687ada7082e79a2a.png";